var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01255 3.56596C5.23839 3.81577 5.23839 4.19048 5.01255 4.4153L1.59975 7.81265C1.34881 8.06245 0.972397 8.06245 0.74655 7.81265L0.169386 7.26308C-0.0564613 7.01327 -0.0564613 6.63856 0.169386 6.41374L2.60351 3.99063L0.169386 1.59251C-0.0564613 1.36768 -0.0564613 0.967994 0.169386 0.743169L0.74655 0.168618C0.972397 -0.0562061 1.34881 -0.0562061 1.59975 0.168618L5.01255 3.56596ZM9.83061 4.4153L6.41782 7.81265C6.16688 8.06245 5.79046 8.06245 5.56462 7.81265L4.98745 7.26308C4.76161 7.01327 4.76161 6.63856 4.98745 6.41374L7.42158 3.99063L4.98745 1.59251C4.76161 1.36768 4.76161 0.967994 4.98745 0.743169L5.56462 0.168618C5.79046 -0.0562061 6.16688 -0.0562061 6.41782 0.168618L9.83061 3.56596C10.0565 3.81577 10.0565 4.19048 9.83061 4.4153Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextAll);
export default __webpack_public_path__ + "static/media/next-all.013769bff3b353b79206964fc0cbb919.svg";
export { ForwardRef as ReactComponent };